import { render } from "./UiButton.vue?vue&type=template&id=cbf84ff2"
import script from "./UiButton.vue?vue&type=script&lang=js"
export * from "./UiButton.vue?vue&type=script&lang=js"

import "./UiButton.vue?vue&type=style&index=0&id=cbf84ff2&lang=css"

import exportComponent from "/home/runner/work/bot-v2/bot-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__